import React from 'react';
import { FormattedMessage } from 'react-intl';
import failureReasons from './transferOfferFailureReasons';
import fieldKeys from './fieldKeys';

export default {
    [fieldKeys.barHeaderTitleSent]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.header.title_sent"
            defaultMessage="Item(s) Transferred!"
        />
    ),
    [fieldKeys.barHeaderTitleFailed]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.header.title_failed"
            defaultMessage="Item(s) Transfer Failed"
        />
    ),
    [fieldKeys.barHeaderSubtitle]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.header.subtitle"
            defaultMessage="Your colleague will now be able to purchase your transferred items with any custom offers that you received from the seller."
        />
    ),
    [fieldKeys.successHeadline]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.listHeader.success"
            defaultMessage="Transfer successful for:"
        />
    ),
    [fieldKeys.failHeadline]: (
        <FormattedMessage
            id="dc.bulkRequestSuccessModal.transferOffer.listHeader.fail"
            defaultMessage="Transfer unsuccessful for:"
        />
    ),
    failureReasons,
};
